import { useState, useMemo } from 'react';
import draftToHtml from 'draftjs-to-html';
import { RawDraftContentState } from 'draft-js';

import { convertRichtextToPlainText } from 'lib/form/richtextarea/richtextarea.utils';
import { PStyled } from 'approot/shared/styles/typography.style';
import { LinkButton } from 'approot/shared/styles/buttons/buttons';
import * as Styled from './read-more.style';

type Props = {
  title: string;
  content: RawDraftContentState;
};

const ReadMoreRichText = ({ title, content }: Props) => {
  const [isPreview, setIsPreview] = useState<boolean>(true);

  const hasMoreText = useMemo(
    () => content && (convertRichtextToPlainText(content)?.length || 0) > 276,
    [content]
  );

  const textContent = (
    <PStyled
      as="div"
      marginBottom={0}
      dangerouslySetInnerHTML={{ __html: draftToHtml(content) }}
    />
  );
  return (
    <>
      {hasMoreText ? (
        <Styled.ReadMoreWrapper isPreview={isPreview}>
          {textContent}
        </Styled.ReadMoreWrapper>
      ) : (
        textContent
      )}
      {hasMoreText && (
        <LinkButton
          type="button"
          aria-label={`${title} read ${isPreview ? 'more' : 'less'}`}
          onClick={() => setIsPreview(!isPreview)}
        >
          Read {isPreview ? 'More' : 'Less'}
        </LinkButton>
      )}
    </>
  );
};

export default ReadMoreRichText;
